import { render, staticRenderFns } from "./receipt.vue?vue&type=template&id=3aa3319c&scoped=true"
import script from "./receipt.vue?vue&type=script&lang=js"
export * from "./receipt.vue?vue&type=script&lang=js"
import style0 from "./receipt.vue?vue&type=style&index=0&id=3aa3319c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3319c",
  null
  
)

export default component.exports